import { Input } from '@heroui/react'

export default function KVInput({ value, onChange }) {
  let currentValue = value

  // Handle case where value is stored as JSON string in URL params
  while (typeof currentValue === 'string') {
    try {
      currentValue = JSON.parse(currentValue)
    }
    catch {
      // Parsing failed – break to avoid infinite loop
      break
    }
  }

  const currentEntries = Object.entries(currentValue)
  const currentKey = currentEntries.length > 0 ? currentEntries[0][0] : ''
  const currentVal = currentEntries.length > 0 ? currentEntries[0][1] : ''

  return (
    <div className="flex w-full flex-row gap-2">
      <Input
        placeholder="Key"
        value={currentKey}
        variant="bordered"
        size="sm"
        fullWidth
        className="flex-1"
        onChange={(e) => {
          const newKey = e.target.value
          const newValue = {}

          if (newKey && currentVal) {
            newValue[newKey] = currentVal
          }
          else if (newKey) {
            newValue[newKey] = ''
          }

          onChange(newValue)
        }}
      />
      <Input
        placeholder="Value"
        value={currentVal}
        variant="bordered"
        size="sm"
        fullWidth
        className="flex-1"
        onChange={(e) => {
          const newVal = e.target.value
          const newValue = {}

          if (currentKey) {
            newValue[currentKey] = newVal
            onChange(newValue)
          }
        }}
      />
    </div>
  )
}
